import { Card, CardContent, CardHeader, CardTitle } from '@/ui/card';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-8">
            <div className="mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-4">Informativa sulla Privacy</h1>
              <p className="text-gray-600">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>
            </div>

            <div className="space-y-8">
              <Card>
                <CardHeader>
                  <CardTitle>1. Informazioni che Raccogliamo</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Dati Aziendali</h4>
                    <p className="text-gray-700">
                      Quando utilizzate il nostro sistema di prenotazione B2B, raccogliamo informazioni aziendali come 
                      ragione sociale, codice fiscale/partita IVA, indirizzo, dati di contatto e informazioni sui 
                      rappresentanti autorizzati dell&rsquo;agenzia di viaggi.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Dati delle Prenotazioni</h4>
                    <p className="text-gray-700">
                      Raccogliamo i dati necessari per elaborare le prenotazioni dei vostri clienti, inclusi 
                      nomi, documenti di identità, informazioni di contatto e preferenze di viaggio.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Dati di Utilizzo</h4>
                    <p className="text-gray-700">
                      Monitoriamo l&rsquo;utilizzo della piattaforma per ottimizzare i servizi, inclusi log di accesso, 
                      statistiche delle prenotazioni e dati tecnici sui dispositivi utilizzati.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>2. Come Utilizziamo le Vostre Informazioni</CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Gestire ed elaborare le prenotazioni effettuate attraverso la vostra agenzia</li>
                    <li>Fornire supporto tecnico e commerciale per l&rsquo;utilizzo della piattaforma</li>
                    <li>Comunicare aggiornamenti sui servizi, tariffe e disponibilità</li>
                    <li>Generare reportistica e analisi per migliorare i nostri servizi</li>
                    <li>Garantire la sicurezza della piattaforma e prevenire frodi</li>
                    <li>Adempiere agli obblighi legali e contrattuali</li>
                    <li>Fatturazione e gestione dei pagamenti B2B</li>
                  </ul>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>3. Condivisione delle Informazioni</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700">
                    Non vendiamo, scambiamo o affittiamo le vostre informazioni aziendali a terze parti. 
                    Condividiamo i dati solo nelle seguenti circostanze:
                  </p>
                  <ul className="list-disc list-inside mt-4 space-y-2 text-gray-700">
                    <li>Con fornitori di servizi turistici (hotel, compagnie aeree, tour operator) per completare le prenotazioni</li>
                    <li>Con processori di pagamento per gestire le transazioni B2B</li>
                    <li>Con autorità competenti quando richiesto per legge o procedimenti legali</li>
                    <li>Per proteggere i nostri diritti e prevenire attività fraudolente</li>
                    <li>Con il vostro consenso esplicito scritto</li>
                  </ul>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>4. Sicurezza dei Dati</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700">
                    Implementiamo misure tecniche e organizzative appropriate per proteggere le informazioni 
                    aziendali contro accessi non autorizzati, alterazioni, divulgazioni o distruzioni. 
                    Utilizziamo crittografia SSL/TLS, controlli di accesso rigorosi e backup sicuri. 
                    Tuttavia, nessun metodo di trasmissione su Internet è sicuro al 100%.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>5. I Vostri Diritti (GDPR)</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700 mb-4">
                    In conformità al Regolamento Generale sulla Protezione dei Dati (GDPR), avete i seguenti diritti:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Diritto di accesso ai dati aziendali trattati</li>
                    <li>Diritto di rettifica delle informazioni inesatte</li>
                    <li>Diritto alla cancellazione in determinate circostanze</li>
                    <li>Diritto alla limitazione del trattamento</li>
                    <li>Diritto alla portabilità dei dati</li>
                    <li>Diritto di opposizione al trattamento</li>
                    <li>Diritto di proporre reclamo all&rsquo;Autorità Garante</li>
                  </ul>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>6. Conservazione dei Dati</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700">
                    Conserviamo i dati aziendali solo per il tempo necessario a fornire i nostri servizi 
                    e per adempiere agli scopi indicati in questa informativa. I dati delle prenotazioni 
                    sono conservati per 10 anni per obblighi fiscali e contabili. I dati di utilizzo 
                    della piattaforma sono conservati per 2 anni a fini statistici e di miglioramento del servizio.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>7. Cookie e Tecnologie di Tracciamento</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700">
                    La nostra piattaforma utilizza cookie tecnici essenziali per il funzionamento del sistema 
                    di prenotazione e cookie analitici per migliorare l&rsquo;esperienza utente. Utilizziamo anche 
                    cookie di sessione per mantenere l&rsquo;autenticazione durante l&rsquo;utilizzo della piattaforma. 
                    Potete gestire le preferenze sui cookie attraverso le impostazioni del vostro browser.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>8. Modifiche a Questa Informativa</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700">
                    Possiamo aggiornare questa informativa sulla privacy periodicamente. Vi notificheremo 
                    eventuali modifiche sostanziali tramite comunicazione diretta via email e aggiornando 
                    la data di &ldquo;ultimo aggiornamento&rdquo; su questa pagina. Le modifiche entreranno in vigore 
                    30 giorni dopo la notifica.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>9. Contatti e Responsabile del Trattamento</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700">
                    Per domande su questa informativa sulla privacy o sul trattamento dei vostri dati aziendali, 
                    potete contattare il nostro Responsabile della Protezione dei Dati:
                  </p>
                  <div className="mt-4 text-gray-700">
                    <p><strong>Titolare del Trattamento:</strong> Baetorra di Emanuel Francisco Barrocoso Daun</p>
                    <p><strong>Email:</strong> info@baetorra.com</p>
                    <p><strong>Telefono:</strong> 340 382 7753</p>
                    <p><strong>Indirizzo:</strong> Via Baronia 4, 07051 Budoni (SS), Italia</p>
                    <p><strong>Partita IVA:</strong> 01599490917</p>
                  </div>
                  <div className="mt-4 text-gray-700">
                    <p className="text-sm">
                      <strong>Autorità di Controllo:</strong> Garante per la Protezione dei Dati Personali<br />
                      Sito web: www.gpdp.it
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}